import React from 'react';

interface SkeletonCardProps {
  darkMode: boolean;
}

const SkeletonCard: React.FC<SkeletonCardProps> = ({ darkMode }) => (
  <div className={`rounded-lg border p-4 animate-pulse ${
    darkMode ? 'bg-appines-petrol border-appines-white/12' : 'bg-appines-white border-[rgba(1,42,54,0.12)]'
  }`}>
    <div className="flex items-start justify-between mb-3">
      <div>
        <div className={`w-16 h-3 rounded mb-2 ${darkMode ? 'bg-appines-white/10' : 'bg-[rgba(1,42,54,0.08)]'}`} />
        <div className={`w-24 h-7 rounded ${darkMode ? 'bg-appines-white/10' : 'bg-[rgba(1,42,54,0.08)]'}`} />
      </div>
      <div className={`w-8 h-8 rounded ${darkMode ? 'bg-appines-white/10' : 'bg-[rgba(1,42,54,0.08)]'}`} />
    </div>
    <div className={`w-3/4 h-5 rounded mb-3 ${darkMode ? 'bg-appines-white/10' : 'bg-[rgba(1,42,54,0.08)]'}`} />
    <div className={`w-full h-4 rounded mb-2 ${darkMode ? 'bg-appines-white/10' : 'bg-[rgba(1,42,54,0.08)]'}`} />
    <div className={`w-2/3 h-4 rounded ${darkMode ? 'bg-appines-white/10' : 'bg-[rgba(1,42,54,0.08)]'}`} />
  </div>
);

export default SkeletonCard;
